<div class="col-12">
    <div class="action-container">
        <h5 class="headline display-5">{{ 'productDetail.headlines.complementaryProducts' | translateSafe }}</h5>
        @if (slider() && slider()?.hasPaging) {
            <div class="kk-slider-buttons">
                <button
                    class="kk-slider-button slider-button"
                    [ngClass]="{ 'button-faded': !slider()?.pagingLeftPossible }"
                    (click)="slider()?.previous()"
                >
                                <span class="arrow kk-float-horizontally-left">
                                    <app-svg-icon aria-hidden="true" iconName="chevron_left"></app-svg-icon>
                                </span>
                    <span class="kk-visuallyhidden"> {{ 'general.action.next' | translateSafe }}</span>
                </button>
                <button
                    class="kk-slider-button slider-button"
                    [ngClass]="{ 'button-faded': !slider()?.pagingRightPossible }"
                    (click)="slider()?.next()"
                >
                                <span class="arrow kk-float-horizontally-right">
                                    <app-svg-icon aria-hidden="true" iconName="chevron_right"> </app-svg-icon>
                                </span>
                    <span class="kk-visuallyhidden">{{ 'general.action.previous' | translateSafe }}</span>
                </button>
            </div>
        }
    </div>
</div>

<div class="container-fluid">
    <div class="slider">
        <div class="slider-container">

            @if (status() === 'loading' || !products().length) {
                <ng-container *ngTemplateOutlet="fetchingProducts"></ng-container>
            } @else {
                <app-slider [scrollByItems]="1" [ngStyle]="{ display: 'grid'}" #slider>
                    @for (product of products(); track product.productNo; let i = $index) {
                        <div
                            class="slider-item"
                            [appImpressionTracking]="product"
                            [index]="i + 1"
                            [impressionSource]="'Product Gallery' | impressionType"
                        >
                            <div class="slider-item-inner">
                                <app-product-card
                                    [line]="product"
                                    [impressionSource]="'Product Gallery' | impressionType"
                                    [compressed]="true"
                                    [displayActions]="true"
                                    [layout]="'mini'"
                                ></app-product-card>
                            </div>
                        </div>
                    }
                </app-slider>
            }

        </div>
    </div>
</div>

<ng-template #fetchingProducts>
    <div class="fetching-wrapper">
        <div class="content">
            @for (item of [].constructor(complementaryProducts()?.length); track item) {
                <div class="placeholder-item">
                    <div class="placeholder-item-inner">
                        <app-loading-dots></app-loading-dots>
                    </div>
                </div>
            }
        </div>
    </div>
</ng-template>
